import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';

const DeleteNodeDialog = ({ open, isSmallScreen, nodeLabel, descendantCount, onCancel, onConfirm }) => {
  const hasChildren = descendantCount > 0;

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth fullScreen={isSmallScreen}>
      <DialogTitle>Delete Cohort Node</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1.25}>
          <Typography variant="body2">
            Are you sure you want to delete <strong>{nodeLabel || 'this node'}</strong>?
          </Typography>
          {hasChildren ? (
            <>
              <Typography variant="body2" color="warning.main">
                This node has {descendantCount} descendant node{descendantCount === 1 ? '' : 's'}.
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Deleting only this node is not allowed because it would create orphaned nodes.
              </Typography>
            </>
          ) : (
            <Typography variant="body2" color="text.secondary">
              This node has no children, so only this node will be removed.
            </Typography>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        {hasChildren ? (
          <>
            <Button color="error" disabled>
              Delete Only (Not Allowed)
            </Button>
            <Button variant="contained" color="error" onClick={() => onConfirm(true)}>
              Delete Node + Descendants
            </Button>
          </>
        ) : (
          <Button variant="contained" color="error" onClick={() => onConfirm(false)}>
            Delete Node
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default DeleteNodeDialog;
